import IframeModal from '../IframeModal';
import { NameCheckControllerService } from '@/__generated__/CommonApi';
import { RegularPayInfoVo } from '@/__generated__/FrontApi';
import { isBrowser } from '@/helpers/BrowserHelper';
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
  VFC,
} from 'react';
import { createPortal } from 'react-dom';

export interface NameCheckMemberInfo {
  birthday?: string; // 1996-12-17 00:00:00.0
  email?: string;
  juminNumber?: string;
  memberName?: string;
  mobilePhoneNumber?: string;
  address?: string;
  addressDetail?: string;
  zipCode?: string;
  mailDm: 'Y' | 'N';
  mailEdm: 'Y' | 'N';
  mailSms: 'Y' | 'N';
}

type SirenResult = {
  type: 'name-check';
  resultCode: 'success' | 'failed';
  resultMessage: string;
  memberInfo: NameCheckMemberInfo;
  payInfo: RegularPayInfoVo;
};

interface SirenParams {
  name: string;
  jumin: string;
}

interface SirenFormData {
  reqInfo: any;
  retUrl: string;
}

interface SirenNameCheckProps {
  onSuccess?: (result: SirenResult) => void;
  onError?: (result: SirenResult) => void;
  renderSubmitButton: (props: { onClick: () => void }) => ReactElement;
  getParams: () => SirenParams;
}

const SirenNameCheck: VFC<SirenNameCheckProps> = ({
  renderSubmitButton,
  onSuccess,
  onError,
  getParams,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const start = useCallback(() => {
    if (!formRef.current) {
      return;
    }
    const params = getParams();
    NameCheckControllerService.sirenNameAuthUsingPost(params).then(
      ({ data: _data }) => {
        if (!formRef.current) {
          return;
        }

        setModalOpen(true);

        const data = _data as SirenFormData;
        formRef.current.reqInfo.value = data.reqInfo;
        formRef.current.ok_url.value = data.retUrl;
        formRef.current.submit();
      },
    );
  }, [getParams]);

  // postMessage 리스너 등록
  useEffect(() => {
    const callback = (e: MessageEvent<SirenResult>) => {
      const { type, resultCode } = e.data;
      if (type !== `name-check`) {
        return;
      }
      setModalOpen(false);
      if (resultCode === `success`) {
        onSuccess?.(e.data);
      } else {
        onError?.(e.data);
      }
    };
    window.addEventListener(`message`, callback, false);
    return () => window.removeEventListener(`message`, callback);
  }, [onError, onSuccess]);

  if (!isBrowser) {
    return null;
  }

  return (
    <>
      {renderSubmitButton({ onClick: start })}
      {createPortal(
        <form
          ref={formRef}
          name="nameCheckForm"
          method="post"
          action="https://name.siren24.com/servlet/name_check_seed"
          target="popupNameChk"
        >
          <input type="hidden" name="reqInfo" readOnly />
          <input type="hidden" name="ok_url" readOnly />
        </form>,
        document.body,
      )}
      <IframeModal
        isOpen={modalOpen}
        name="popupNameChk"
        maxWidth="500px"
        hideContent
        onRequestClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default SirenNameCheck;
